import { createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue";
const _hoisted_1 = { class: "x_panel" };
const _hoisted_2 = /*#__PURE__*/ _createElementVNode("div", { class: "x_title" }, [
    /*#__PURE__*/ _createElementVNode("h3", null, "Active License")
], -1 /* HOISTED */);
const _hoisted_3 = { class: "x_content" };
const _hoisted_4 = { class: "row" };
const _hoisted_5 = /*#__PURE__*/ _createElementVNode("h4", null, "License Details", -1 /* HOISTED */);
const _hoisted_6 = {
    key: 0,
    class: "table"
};
const _hoisted_7 = /*#__PURE__*/ _createElementVNode("th", null, "License ID", -1 /* HOISTED */);
const _hoisted_8 = /*#__PURE__*/ _createElementVNode("th", null, "Issued For", -1 /* HOISTED */);
const _hoisted_9 = /*#__PURE__*/ _createElementVNode("th", null, "Edition", -1 /* HOISTED */);
const _hoisted_10 = /*#__PURE__*/ _createElementVNode("th", null, "Product Code", -1 /* HOISTED */);
const _hoisted_11 = /*#__PURE__*/ _createElementVNode("th", null, "Created", -1 /* HOISTED */);
const _hoisted_12 = /*#__PURE__*/ _createElementVNode("th", null, "Start Date", -1 /* HOISTED */);
const _hoisted_13 = /*#__PURE__*/ _createElementVNode("th", null, "End Date", -1 /* HOISTED */);
const _hoisted_14 = /*#__PURE__*/ _createElementVNode("th", null, "Grace Period", -1 /* HOISTED */);
const _hoisted_15 = {
    key: 0,
    class: "col-xs-12 col-sm-12 col-md-6"
};
const _hoisted_16 = /*#__PURE__*/ _createElementVNode("h4", null, "String Quota", -1 /* HOISTED */);
const _hoisted_17 = { key: 0 };
const _hoisted_18 = { class: "table" };
const _hoisted_19 = /*#__PURE__*/ _createElementVNode("thead", null, [
    /*#__PURE__*/ _createElementVNode("tr", null, [
        /*#__PURE__*/ _createElementVNode("th", null, "Monitor Type"),
        /*#__PURE__*/ _createTextVNode(),
        /*#__PURE__*/ _createElementVNode("th", null, "Battery Type"),
        /*#__PURE__*/ _createTextVNode(),
        /*#__PURE__*/ _createElementVNode("th", null, "String Count")
    ])
], -1 /* HOISTED */);
const _hoisted_20 = { key: 0 };
const _hoisted_21 = { class: "table fw-bold" };
const _hoisted_22 = /*#__PURE__*/ _createElementVNode("td", { colspan: "2" }, "Total", -1 /* HOISTED */);
const _hoisted_23 = {
    key: 0,
    class: "mt-3"
};
const _hoisted_24 = { class: "alert alert-primary" };
const _hoisted_25 = /*#__PURE__*/ _createElementVNode("strong", null, "Features restricted by string quota:", -1 /* HOISTED */);
const _hoisted_26 = /*#__PURE__*/ _createElementVNode("br", null, null, -1 /* HOISTED */);
const _hoisted_27 = /*#__PURE__*/ _createElementVNode("i", { class: "fa fa-desktop" }, null, -1 /* HOISTED */);
const _hoisted_28 = { key: 1 };
const _hoisted_29 = /*#__PURE__*/ _createElementVNode("p", { class: "text-muted" }, "No string quota defined.", -1 /* HOISTED */);
const _hoisted_30 = [
    _hoisted_29
];
const _hoisted_31 = {
    key: 0,
    class: "x_panel"
};
const _hoisted_32 = /*#__PURE__*/ _createElementVNode("div", { class: "x_title" }, [
    /*#__PURE__*/ _createElementVNode("h3", null, "Rejected License")
], -1 /* HOISTED */);
const _hoisted_33 = { class: "x_content" };
const _hoisted_34 = /*#__PURE__*/ _createElementVNode("div", {
    class: "alert alert-primary",
    role: "alert"
}, "\r\n                    Provided license file was resolved but could not be applied. The details below show the license information from the file.\r\n                    Please contact support if you believe this license should be valid/active.\r\n                ", -1 /* HOISTED */);
const _hoisted_35 = { class: "row" };
const _hoisted_36 = /*#__PURE__*/ _createElementVNode("h4", null, "License Details", -1 /* HOISTED */);
const _hoisted_37 = { class: "table" };
const _hoisted_38 = /*#__PURE__*/ _createElementVNode("th", null, "License ID", -1 /* HOISTED */);
const _hoisted_39 = /*#__PURE__*/ _createElementVNode("th", null, "Issued For", -1 /* HOISTED */);
const _hoisted_40 = /*#__PURE__*/ _createElementVNode("th", null, "Edition", -1 /* HOISTED */);
const _hoisted_41 = /*#__PURE__*/ _createElementVNode("th", null, "Product Code", -1 /* HOISTED */);
const _hoisted_42 = /*#__PURE__*/ _createElementVNode("th", null, "Created", -1 /* HOISTED */);
const _hoisted_43 = /*#__PURE__*/ _createElementVNode("th", null, "Start Date", -1 /* HOISTED */);
const _hoisted_44 = /*#__PURE__*/ _createElementVNode("th", null, "End Date", -1 /* HOISTED */);
const _hoisted_45 = /*#__PURE__*/ _createElementVNode("th", null, "Grace Period", -1 /* HOISTED */);
const _hoisted_46 = {
    key: 0,
    class: "col-xs-12 col-sm-12 col-md-6"
};
const _hoisted_47 = /*#__PURE__*/ _createElementVNode("h4", null, "String Quota", -1 /* HOISTED */);
const _hoisted_48 = { key: 0 };
const _hoisted_49 = { class: "table" };
const _hoisted_50 = /*#__PURE__*/ _createElementVNode("thead", null, [
    /*#__PURE__*/ _createElementVNode("tr", null, [
        /*#__PURE__*/ _createElementVNode("th", null, "Monitor Type"),
        /*#__PURE__*/ _createTextVNode(),
        /*#__PURE__*/ _createElementVNode("th", null, "Battery Type"),
        /*#__PURE__*/ _createTextVNode(),
        /*#__PURE__*/ _createElementVNode("th", null, "String Count")
    ])
], -1 /* HOISTED */);
const _hoisted_51 = { key: 0 };
const _hoisted_52 = { class: "table-secondary fw-bold" };
const _hoisted_53 = /*#__PURE__*/ _createElementVNode("td", { colspan: "2" }, "Total", -1 /* HOISTED */);
const _hoisted_54 = { key: 1 };
const _hoisted_55 = /*#__PURE__*/ _createElementVNode("p", { class: "text-muted" }, "No string quota defined.", -1 /* HOISTED */);
const _hoisted_56 = [
    _hoisted_55
];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o;
    const _component_b_button = _resolveComponent("b-button");
    const _component_system_coverage_modal = _resolveComponent("system-coverage-modal");
    return (_openBlock(), _createElementBlock("div", null, [
        _createElementVNode("div", _hoisted_1, [
            _hoisted_2,
            _createTextVNode(),
            _createElementVNode("div", _hoisted_3, [
                _createCommentVNode(" Status Message Alert "),
                _createTextVNode(),
                (((_a = _ctx.license) === null || _a === void 0 ? void 0 : _a.statusMessage) && !((_b = _ctx.license) === null || _b === void 0 ? void 0 : _b.rejectedLicense))
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        class: _normalizeClass(['alert', _ctx.statusAlertClass]),
                        role: "alert"
                    }, _toDisplayString(_ctx.license.statusMessage), 3 /* TEXT, CLASS */))
                    : _createCommentVNode("v-if", true),
                _createTextVNode(),
                _createElementVNode("div", _hoisted_4, [
                    _createCommentVNode(" License Details Column "),
                    _createTextVNode(),
                    _createElementVNode("div", {
                        class: _normalizeClass(_ctx.isSystemConstrainedEdition ? 'col-xs-12 col-sm-12 col-md-6' : 'col-md-12')
                    }, [
                        _hoisted_5,
                        _createTextVNode(),
                        ((_c = _ctx.license) === null || _c === void 0 ? void 0 : _c.activeLicense)
                            ? (_openBlock(), _createElementBlock("table", _hoisted_6, [
                                _createElementVNode("tbody", null, [
                                    _createElementVNode("tr", null, [
                                        _hoisted_7,
                                        _createTextVNode(),
                                        _createElementVNode("td", null, _toDisplayString((_d = _ctx.license.activeLicense.licenseId) !== null && _d !== void 0 ? _d : 'N/A'), 1 /* TEXT */)
                                    ]),
                                    _createTextVNode(),
                                    _createElementVNode("tr", null, [
                                        _hoisted_8,
                                        _createTextVNode(),
                                        _createElementVNode("td", null, _toDisplayString(_ctx.license.activeLicense.issuedFor), 1 /* TEXT */)
                                    ]),
                                    _createTextVNode(),
                                    _createElementVNode("tr", null, [
                                        _hoisted_9,
                                        _createTextVNode(),
                                        _createElementVNode("td", null, _toDisplayString(_ctx.formatEdition(_ctx.license.activeLicense.assureEdition)), 1 /* TEXT */)
                                    ]),
                                    _createTextVNode(),
                                    _createElementVNode("tr", null, [
                                        _hoisted_10,
                                        _createTextVNode(),
                                        _createElementVNode("td", null, _toDisplayString(_ctx.license.activeLicense.productCode), 1 /* TEXT */)
                                    ]),
                                    _createTextVNode(),
                                    _createElementVNode("tr", null, [
                                        _hoisted_11,
                                        _createTextVNode(),
                                        _createElementVNode("td", null, _toDisplayString(_ctx.formatDate(_ctx.license.activeLicense.whenCreated)), 1 /* TEXT */)
                                    ]),
                                    _createTextVNode(),
                                    _createElementVNode("tr", null, [
                                        _hoisted_12,
                                        _createTextVNode(),
                                        _createElementVNode("td", null, _toDisplayString(_ctx.formatDate(_ctx.license.activeLicense.startDate)), 1 /* TEXT */)
                                    ]),
                                    _createTextVNode(),
                                    _createElementVNode("tr", null, [
                                        _hoisted_13,
                                        _createTextVNode(),
                                        _createElementVNode("td", null, _toDisplayString(_ctx.formatDate(_ctx.license.activeLicense.endDate)), 1 /* TEXT */)
                                    ]),
                                    _createTextVNode(),
                                    _createElementVNode("tr", null, [
                                        _hoisted_14,
                                        _createTextVNode(),
                                        _createElementVNode("td", null, _toDisplayString(_ctx.formatGracePeriod(_ctx.license.activeLicense.gracePeriodSecs)), 1 /* TEXT */)
                                    ])
                                ])
                            ]))
                            : _createCommentVNode("v-if", true)
                    ], 2 /* CLASS */),
                    _createTextVNode(),
                    _createCommentVNode(" String Quota Column (only for system-constrained editions) "),
                    _createTextVNode(),
                    (_ctx.isSystemConstrainedEdition)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                            _hoisted_16,
                            _createTextVNode(),
                            ((_g = (_f = (_e = _ctx.license) === null || _e === void 0 ? void 0 : _e.activeLicense) === null || _f === void 0 ? void 0 : _f.stringCounts) === null || _g === void 0 ? void 0 : _g.length)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                                    _createElementVNode("table", _hoisted_18, [
                                        _hoisted_19,
                                        _createTextVNode(),
                                        _createElementVNode("tbody", null, [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.license.activeLicense.stringCounts, (quota, index) => {
                                                return (_openBlock(), _createElementBlock("tr", { key: index }, [
                                                    _createElementVNode("td", null, _toDisplayString(_ctx.formatMonitorType(quota.monitorType)), 1 /* TEXT */),
                                                    _createTextVNode(),
                                                    _createElementVNode("td", null, _toDisplayString(_ctx.formatBatteryType(quota.batteryType)), 1 /* TEXT */),
                                                    _createTextVNode(),
                                                    _createElementVNode("td", null, _toDisplayString(quota.stringCount), 1 /* TEXT */)
                                                ]));
                                            }), 128 /* KEYED_FRAGMENT */))
                                        ]),
                                        _createTextVNode(),
                                        (_ctx.license.activeLicense.stringCounts.length > 1)
                                            ? (_openBlock(), _createElementBlock("tfoot", _hoisted_20, [
                                                _createElementVNode("tr", _hoisted_21, [
                                                    _hoisted_22,
                                                    _createTextVNode(),
                                                    _createElementVNode("td", null, _toDisplayString(_ctx.getTotalStringCount(_ctx.license.activeLicense.stringCounts)), 1 /* TEXT */)
                                                ])
                                            ]))
                                            : _createCommentVNode("v-if", true)
                                    ]),
                                    _createTextVNode(),
                                    _createCommentVNode(" Constrained Features Info "),
                                    _createTextVNode(),
                                    ((_j = (_h = _ctx.featureConstraints) === null || _h === void 0 ? void 0 : _h.constrainedFeatures) === null || _j === void 0 ? void 0 : _j.length)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                                            _createElementVNode("div", _hoisted_24, [
                                                _hoisted_25,
                                                _hoisted_26,
                                                _createTextVNode(),
                                                _createElementVNode("span", null, _toDisplayString(_ctx.featureConstraints.constrainedFeatures.join(', ')), 1 /* TEXT */)
                                            ])
                                        ]))
                                        : _createCommentVNode("v-if", true),
                                    _createTextVNode(),
                                    _createCommentVNode(" View System Coverage Button "),
                                    _createTextVNode(),
                                    _createVNode(_component_b_button, {
                                        variant: "primary",
                                        onClick: _cache[0] || (_cache[0] = ($event) => (_ctx.systemCoverageModal.showModal()))
                                    }, {
                                        default: _withCtx(() => [
                                            _hoisted_27,
                                            _createTextVNode("  View System Coverage\r\n                            ")
                                        ]),
                                        _: 1 /* STABLE */
                                    })
                                ]))
                                : (_openBlock(), _createElementBlock("div", _hoisted_28, _hoisted_30))
                        ]))
                        : _createCommentVNode("v-if", true)
                ])
            ])
        ]),
        _createTextVNode(),
        _createCommentVNode(" Rejected License Panel "),
        _createTextVNode(),
        ((_k = _ctx.license) === null || _k === void 0 ? void 0 : _k.rejectedLicense)
            ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                _hoisted_32,
                _createTextVNode(),
                _createElementVNode("div", _hoisted_33, [
                    _hoisted_34,
                    _createTextVNode(),
                    _createCommentVNode(" Status Message Alert "),
                    _createTextVNode(),
                    ((_l = _ctx.license) === null || _l === void 0 ? void 0 : _l.statusMessage)
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 0,
                            class: _normalizeClass(['alert', _ctx.statusAlertClass]),
                            role: "alert"
                        }, _toDisplayString(_ctx.license.statusMessage), 3 /* TEXT, CLASS */))
                        : _createCommentVNode("v-if", true),
                    _createTextVNode(),
                    _createElementVNode("div", _hoisted_35, [
                        _createCommentVNode(" License Details Column "),
                        _createTextVNode(),
                        _createElementVNode("div", {
                            class: _normalizeClass(_ctx.isRejectedLicenseSystemConstrained ? 'col-xs-12 col-sm-12 col-md-6' : 'col-md-12')
                        }, [
                            _hoisted_36,
                            _createTextVNode(),
                            _createElementVNode("table", _hoisted_37, [
                                _createElementVNode("tbody", null, [
                                    _createElementVNode("tr", null, [
                                        _hoisted_38,
                                        _createTextVNode(),
                                        _createElementVNode("td", null, _toDisplayString((_m = _ctx.license.rejectedLicense.licenseId) !== null && _m !== void 0 ? _m : 'N/A'), 1 /* TEXT */)
                                    ]),
                                    _createTextVNode(),
                                    _createElementVNode("tr", null, [
                                        _hoisted_39,
                                        _createTextVNode(),
                                        _createElementVNode("td", null, _toDisplayString(_ctx.license.rejectedLicense.issuedFor), 1 /* TEXT */)
                                    ]),
                                    _createTextVNode(),
                                    _createElementVNode("tr", null, [
                                        _hoisted_40,
                                        _createTextVNode(),
                                        _createElementVNode("td", null, _toDisplayString(_ctx.formatEdition(_ctx.license.rejectedLicense.assureEdition)), 1 /* TEXT */)
                                    ]),
                                    _createTextVNode(),
                                    _createElementVNode("tr", null, [
                                        _hoisted_41,
                                        _createTextVNode(),
                                        _createElementVNode("td", null, _toDisplayString(_ctx.license.rejectedLicense.productCode), 1 /* TEXT */)
                                    ]),
                                    _createTextVNode(),
                                    _createElementVNode("tr", null, [
                                        _hoisted_42,
                                        _createTextVNode(),
                                        _createElementVNode("td", null, _toDisplayString(_ctx.formatDate(_ctx.license.rejectedLicense.whenCreated)), 1 /* TEXT */)
                                    ]),
                                    _createTextVNode(),
                                    _createElementVNode("tr", null, [
                                        _hoisted_43,
                                        _createTextVNode(),
                                        _createElementVNode("td", null, _toDisplayString(_ctx.formatDate(_ctx.license.rejectedLicense.startDate)), 1 /* TEXT */)
                                    ]),
                                    _createTextVNode(),
                                    _createElementVNode("tr", null, [
                                        _hoisted_44,
                                        _createTextVNode(),
                                        _createElementVNode("td", null, _toDisplayString(_ctx.formatDate(_ctx.license.rejectedLicense.endDate)), 1 /* TEXT */)
                                    ]),
                                    _createTextVNode(),
                                    _createElementVNode("tr", null, [
                                        _hoisted_45,
                                        _createTextVNode(),
                                        _createElementVNode("td", null, _toDisplayString(_ctx.formatGracePeriod(_ctx.license.rejectedLicense.gracePeriodSecs)), 1 /* TEXT */)
                                    ])
                                ])
                            ])
                        ], 2 /* CLASS */),
                        _createTextVNode(),
                        _createCommentVNode(" String Quota Column (only for system-constrained editions) "),
                        _createTextVNode(),
                        (_ctx.isRejectedLicenseSystemConstrained)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_46, [
                                _hoisted_47,
                                _createTextVNode(),
                                ((_o = _ctx.license.rejectedLicense.stringCounts) === null || _o === void 0 ? void 0 : _o.length)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_48, [
                                        _createElementVNode("table", _hoisted_49, [
                                            _hoisted_50,
                                            _createTextVNode(),
                                            _createElementVNode("tbody", null, [
                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.license.rejectedLicense.stringCounts, (quota, index) => {
                                                    return (_openBlock(), _createElementBlock("tr", { key: index }, [
                                                        _createElementVNode("td", null, _toDisplayString(_ctx.formatMonitorType(quota.monitorType)), 1 /* TEXT */),
                                                        _createTextVNode(),
                                                        _createElementVNode("td", null, _toDisplayString(_ctx.formatBatteryType(quota.batteryType)), 1 /* TEXT */),
                                                        _createTextVNode(),
                                                        _createElementVNode("td", null, _toDisplayString(quota.stringCount), 1 /* TEXT */)
                                                    ]));
                                                }), 128 /* KEYED_FRAGMENT */))
                                            ]),
                                            _createTextVNode(),
                                            (_ctx.license.rejectedLicense.stringCounts.length > 1)
                                                ? (_openBlock(), _createElementBlock("tfoot", _hoisted_51, [
                                                    _createElementVNode("tr", _hoisted_52, [
                                                        _hoisted_53,
                                                        _createTextVNode(),
                                                        _createElementVNode("td", null, _toDisplayString(_ctx.getTotalStringCount(_ctx.license.rejectedLicense.stringCounts)), 1 /* TEXT */)
                                                    ])
                                                ]))
                                                : _createCommentVNode("v-if", true)
                                        ])
                                    ]))
                                    : (_openBlock(), _createElementBlock("div", _hoisted_54, _hoisted_56))
                            ]))
                            : _createCommentVNode("v-if", true)
                    ])
                ])
            ]))
            : _createCommentVNode("v-if", true),
        _createTextVNode(),
        _createVNode(_component_system_coverage_modal, { ref: "systemCoverageModal" }, null, 512 /* NEED_PATCH */)
    ]));
}
